<template>
  <label
    class="base-checkbox"
  >
    <input
      type="checkbox"
      class="base-checkbox__input"
      :class="{ boxClass }"
      :checked="shouldBeChecked"
      :value="value"
      @change="updateInput"
      :name="name"
      :disabled="disabled"
    />
    <div
      class="base-checkbox__fill-square base-checkbox__fill-square--active-input tw-bg-[#F3F4F7] !tw-border-[#F3F4F7] tw-rounded-[3px] tw-mt-[2px]"
      :class="[
        boxClass,
        { 'base-checkbox__fill-square--inverted': inverted },
        { '!tw-border-red-600': error },
      ]"
    ></div>
    <span
      class="tw-text-[12px] 3xl:tw-text-[14px] 4xl:tw-text-[18px] baseCheckboxV3-slot"
      :class="{ 'tw-text-red-600 animate__animated animate__flash': error }"
    >
      <slot>Лучший чекбокс</slot>
    </span>
  </label>
</template>
<script>
export default {
  model: {
    prop: "modelValue",
    event: "change",
  },
  props: {
    error: {
      type: Boolean,
    },
    value: {
      type: Number,
    },
    modelValue: {
      default: false,
    },
    inputName: {
      default: "",
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    trueValue: {
      default: 1,
    },
    falseValue: {
      default: 0,
    },
    name: {
      default: "",
    },
    signClass: {
      default: "",
    },
    additionalParams: {
      default: () => {},
    },
    boxClass: {
      default: "",
    },
    inverted: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    shouldBeChecked() {
      if (this.modelValue instanceof Array) {
        return this.modelValue.includes(this.value);
      }

      return this.modelValue == this.trueValue;
    },
  },
  methods: {
    updateInput(event) {
      let isChecked = event.target.checked;
      if (this.modelValue instanceof Array) {
        let newValue = [...this.modelValue];

        if (isChecked) {
          newValue.push(this.value);
        } else {
          newValue.splice(newValue.indexOf(this.value), 1);
        }

        this.$emit("oncheckeds", {
          name: this.inputName,
          value: Number(newValue),
        });
      } else {
        this.$emit("oncheckeds", {
          name: this.inputName,
          value: isChecked ? this.trueValue : this.falseValue,
          ...this.additionalParams,
        });
      }
    },
  },
};
</script>

<style>
.baseCheckboxV3-slot a {
  color: #213960 !important;
  text-decoration: underline !important;
}
</style>
